import rootReducer from '../../shared/redux/reducers/root';
import { configureStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';

export const createVacationFinderStore = (initialState) => {
  const finderStore = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(thunkMiddleware),
    preloadedState: initialState,
  });

  return finderStore;
};
